








import Vue from "vue";
import Component from "vue-class-component";
import Item from "@/components/leader/index.vue";
import { data } from "./data";
@Component({
  components: {
    Item
  }
})
export default class Leader extends Vue {
  list = data;
}
